// ── Per-tenant terminology ──
// User-facing labels that a tenant might want to rename (e.g. "Draw" -> "Advance").
// Use t("draw") instead of hardcoding the word. Any label NOT in this dictionary can stay
// hardcoded; only route the ones you're willing to let tenants rename through here.
//
// Override per tenant with a build-time env var (single-tenant-per-deployment model):
//   REACT_APP_TERMS_JSON = {"draw":"Advance","draws":"Advances","drawFundedBy":"Advance Funded By"}
// (only the keys you want to change). Or call configureTerms(obj) with an API-sourced config.

const DEFAULT_TERMS = {
  // Draws
  draw:            "Draw",
  draws:           "Draws",
  addDraw:         "Add Draw",
  editDraw:        "Edit Draw",
  viewDraw:        "View Draw",
  drawRequestedBy: "Draw Requested By",
  drawFundedBy:    "Draw Funded By",
  // Borrowers / accounts (common rename targets — extend as needed)
  account:         "Account",
  accounts:        "Accounts",
  loan:            "Loan",
  loans:           "Loans",
  borrower:        "Borrower",
};

let TERMS = { ...DEFAULT_TERMS };

// Merge tenant overrides over the defaults. Safe to call with null/partial.
export function configureTerms(overrides) {
  TERMS = { ...DEFAULT_TERMS, ...(overrides || {}) };
}

// Read the build-time terms config (per-tenant bundle). Returns null if unset/invalid.
export function loadTermsFromEnv() {
  try { return JSON.parse(process.env.REACT_APP_TERMS_JSON || "null"); }
  catch (e) { return null; }
}

// Look up a term. Falls back to the provided default, then the key itself.
export function t(key, fallback) {
  return (key in TERMS) ? TERMS[key] : (fallback !== undefined ? fallback : key);
}
